import PublicIcon from '@mui/icons-material/Public';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import { useTheme } from '@mui/material';
import { Box } from '@ovComponents/1-primative/box/box';
import { Typography } from '@ovComponents/1-primative/typography/typography';
import { useThemeTokens } from '@providers/themeTokenProvider';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

export type DriftQueueFooterProps = {
  shown: number;
  total: number;
};

export const DriftQueueFooter: FC<DriftQueueFooterProps> = ({
  shown,
  total,
}) => {
  const { t } = useTranslation(['driftQueue']);
  const theme = useTheme();
  const { sys } = useThemeTokens();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mt: 2,
        px: 1,
      }}
    >
      <Typography variant='bodySmall' colorVariant='variant'>
        {t('driftQueue:footer.rowCount', { shown, total })}
      </Typography>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Typography variant='labelSmall' weight='bold'>
          {t('driftQueue:legend.title')}:
        </Typography>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Box
            sx={{
              width: 12,
              height: 12,
              borderRadius: 0.5,
              backgroundColor: sys.color.warning,
            }}
          />
          <Typography variant='labelSmall'>
            {t('driftQueue:legend.singleBreach')}
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Box
            sx={{
              width: 12,
              height: 12,
              borderRadius: 0.5,
              backgroundColor: sys.color.negative,
            }}
          />
          <Typography variant='labelSmall'>
            {t('driftQueue:legend.compoundBreach')}
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <ReportProblemIcon
            sx={{ fontSize: 14, color: theme.palette.warning.dark }}
          />
          <Typography variant='labelSmall'>
            {t('driftQueue:legend.stale')}
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <PublicIcon
            sx={{ fontSize: 14, color: sys.color.onSurfaceVariant }}
          />
          <Typography variant='labelSmall'>
            {t('driftQueue:legend.international')}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
